import { AbstractMesh, Ray, Vector3 } from '@babylonjs/core';
import { BaseSystem, SystemOperationDefinition, Zed } from '@modules/core';
import { World } from 'miniplex';

import { TourDanjiCameraAPI } from '../../camera';
import { Entity as BaseEntity } from '../Entity';

type Entity = BaseEntity;

export class DisableCollidedDongSystem implements BaseSystem {
  static readonly INJECTABLE_TOKEN = Symbol.for('DisableCollidedDongSystem');

  private readonly withDong;

  private readonly cameraAPI;

  constructor({
    [Zed.WORLD_TOKEN]: world,
    [TourDanjiCameraAPI.INJECTABLE_TOKEN]: cameraApi,
  }: {
    [Zed.WORLD_TOKEN]: World<Entity>;
    [TourDanjiCameraAPI.INJECTABLE_TOKEN]: TourDanjiCameraAPI;
  }) {
    this.withDong = world.with('Dong', 'TransformNode');

    this.cameraAPI = cameraApi;
  }

  /**
   * 위로 레이를 쏴서 충돌체크를 한다.
   *
   * 충돈된 동들은 카메라가 내부에 있다고 간주하여 숨긴다.
   *
   * @remarks 필로티 등 예외 존재
   */
  private checkCollisions = () => {
    const position = this.cameraAPI.camera.position;
    const direction = this.cameraAPI.camera.target.subtract(position).normalize();
    const ray = new Ray(position.add(direction.scale(this.cameraAPI.camera.minZ)), Vector3.UpReadOnly);

    for (const entity of this.withDong) {
      const { TransformNode, DanjiMeshes } = entity;

      const meshes = [
        ...(TransformNode instanceof AbstractMesh ? [TransformNode] : []),
        ...(DanjiMeshes?.danjiMeshes?.flatMap((m) => m.meshes) ?? []),
      ].filter((mesh, index, self) => mesh.isPickable && self.indexOf(mesh) === index);

      const intersected = ray.intersectsMeshes(meshes, true).some((info) => info.hit);

      TransformNode.setEnabled(!intersected);
    }
  };

  readonly operations: SystemOperationDefinition[] = [
    {
      group: 'viewMatrixChanged',
      run: this.checkCollisions,
    },
  ];
}
